import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CallMenu from './call-menu.js';
import { skipAdminTime, getcontactImmediately } from '../actions/autoDialerConfig';
import { toast } from 'react-toastify';
import moment from 'moment-timezone';
import { getAuotoDialerCalls, setAutoDialerCalls, getScheduledAuotoDialerCalls } from '../actions/getCalls';
import CallsModal from './modals/callsModal';
import ScheduledCalls from './modals/ScheduledCalls';
import { doCall, showWebphone } from '../actions/call';
import { toastErrorMsg, logData } from '../utils/utils.js';
import { fadeOutEffect } from '../utils/animationutils.js';
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";

const SKIP_ADMIN_TIME = 'skipAdminTime', CONTACT_IMMEDIATELY = 'contactImmediately';

class AutomotivePanel extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: true,
			showCallsModal: false,
			showScheduledCallsModal: false,
			processingSkipAdminTime: false,
			successSkipAdminTime: false,
			processingGetcontactImmediately: false,
			successGetcontactImmediately: false,
			columns: [
				{ title: 'hour', key: 'date_start', time: true, style: { width: '165px' } },
				{ title: 'service', key: 'service_name', style: { width: '165px' }, filter: true },
				{ title: 'number', key: 'called_phone', doCall: true, style: { width: '165px' }, filter: true },
				{ title: 'region', key: 'geographic_zone', style: { width: '165px' }, filter: true },
				{ title: 'onCall', key: 'speaking', operation: 'subtract', firstItem: 'date_end', secondItem: 'date_start', style: { width: '120px' } },
				{ title: 'duration', key: 'duration', operation: 'subtract', firstItem: 'date_end', secondItem: 'date_start', style: { width: '100px' } },
			],
			scheduledCallsColumns: [
				{ title: 'contactId', key: 'contact_id', style: { width: '100%', verticalAlign: 'middle' } },
				{ title: 'list_detail_id', key: 'list_detail_id', style: { width: '100%', verticalAlign: 'middle' }, filter: true },
				{ title: 'service', key: 'service_name', style: { width: '100%', verticalAlign: 'middle' }, filter: true },
				{ title: 'scheduled', key: 'scheduled_date', time: true, style: { width: '100%', verticalAlign: 'middle' } },
				{ title: 'phones', key: 'phone', style: { width: '100%', verticalAlign: 'middle' } }
			],
			link_disabled: false,
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.outgoingEvent !== this.props.outgoingEvent) {
			setTimeout(() => {
				this.getAuotoDialerCallsList();
			}, 5000);
		}
	}
	// gets list of calls
	getAuotoDialerCallsList = () => {
		this.props.getAuotoDialerCalls().then((res) => {
		}, (err) => {
			logData(err);
		});
	}
	// refetches calls
	refreshCalls = () => {
		this.props.getAuotoDialerCalls();
	}
	handleMouseDown = (event) => {
		this.setState({
		  startX: event.pageX,
		  startY: event.pageY,
		  didMove: false,
		});
	  };
	  handleMouseUp = (event) => {
		const deltaX = event.pageX - this.state.startX;
		const deltaY = event.pageY - this.state.startY;
		const euclides = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
	
		this.setState({
		  didMove: euclides > 5, // radiusLimit = 5
		});
		// console.log(this.state.didMove);
	  };
	
	  handleClick = (item) => (e) => {
		// console.log(item)
		if (!this.state.didMove) {
            if (! this.state.link_disabled)
            {
                // console.log('CLICK no more!! Panel Llamadas automotor');
                this.state.link_disabled = true;
                setTimeout(() => { 
                    this.state.link_disabled = false;
                    // console.log('CLICK ok!! Panel Llamadas automotor');
                }, 5000);

                // console.log('LLAMAR POR AUTOMOTIVE DE CARROS PANEL');
                this.props.showWebphone(true);    
                const payload = {
        			phoneNumber: item.called_phone,
    		    };
    		    this.props.doCall(payload);
            }
		}
	}
	// makes phone call
	// handleCall = (e) => {
	// 	const payload = {
	// 		phoneNumber: e.target.id
	// 	};
	// 	this.props.doCall(payload);
	// }

	close = (key) => {
		this.setState({ [key]: false });
	}

	open = (key) => {
		this.setState({ [key]: true });
	}
	/**
   * updates call list with updated end business
   * @param  {string} callId
   * @param  {string} end_business_id
   * @param  {string} end_business    name of end business
   */
	outgoingServiceCb = (callId, end_business_id, end_business) => {
		const calls = this.props.autoDialerCalls.map(item => item.call_id !== callId ? item : { ...item, end_business_id, end_business });
		this.props.setAutoDialerCalls(calls);
	}
	// updates schedule date for current calls.
	rescheduleCallCb = (callId, schedule_date, schedule_service) => {
		const calls = this.props.autoDialerCalls.map(item => item.call_id !== callId ? item : { ...item, schedule_date, schedule_service });
		this.props.setAutoDialerCalls(calls);
	}

	skipAdminTime = (e) => {
		e.preventDefault();
		this.setState({ processingSkipAdminTime: true });
		this.props.skipAdminTime().then(() => {
			this.setState({ processingSkipAdminTime: false, successSkipAdminTime: true });
			this.fadeOutSuccessIcon(SKIP_ADMIN_TIME);
		}, (err) => {
			this.setState({ processingSkipAdminTime: false });
			toastErrorMsg(this.props.translations.commonErrorText[this.props.selectedLanguage], this, "commonErrToast");
			logData(err);
		});
	}

	getcontactImmediately = (e) => {
		e.preventDefault();
		this.setState({ processingGetcontactImmediately: true });
		this.props.getcontactImmediately().then(() => {
			this.setState({ processingGetcontactImmediately: false, successGetcontactImmediately: true });
			this.fadeOutSuccessIcon(CONTACT_IMMEDIATELY);
		}, (err) => {
			this.setState({ processingGetcontactImmediately: false });
			toastErrorMsg(this.props.translations.commonErrorText[this.props.selectedLanguage], this, "commonErrToast");
			logData(err);
		});
	}

	fadeOutSuccessIcon = (selectedElement) => {
		setTimeout(() => {
			if (selectedElement === SKIP_ADMIN_TIME) {
				fadeOutEffect(this.skipAdminSuccessIcon, () => {
					this.setState({ successSkipAdminTime: false });
				});
			}
			else if (selectedElement === CONTACT_IMMEDIATELY) {
				fadeOutEffect(this.contactImmediatelySuccessIcon, () => {
					this.setState({ successGetcontactImmediately: false });
				});
			}

		}, 2000);
	}
	// renders calls list
	renderCalls = () => {
		return this.props.autoDialerCalls.slice(0, 5).map((item) => {
			return (
				<tr key={item.call_id}>
					<td>{moment.tz(item.date_start * 1000, this.props.agentInfo.timezone).format('HH:mm')}</td>
					<td style={{whiteSpace: "nowrap"}} >{item.service_name}</td>
					<td
						style={{ maxWidth: 120, wordBreak: 'break-all', whiteSpace: "nowrap" }}
						className="cursor"
						onMouseDown={this.handleMouseDown}
           				onMouseUp={this.handleMouseUp}
						id={item.called_phone}
						onClick={this.handleClick(item)}
					>
						{item.called_phone}
					</td>
					<td style={{width:"80px"}}>
						<CallMenu
							CallId={item.call_id}
							phoneNumber={item.called_phone}
							serviceId={item.service_id}
							disableOptions={parseInt(item.end_business_id) !== 0}
							endBusinessId={parseInt(item.end_business_id)}
							endBusiness={item.end_business_call_name}
							has_tags={item.has_tags}
							getCalls={this.refreshCalls}
							outgoingServiceCb={this.outgoingServiceCb}
							rescheduleCallCb={this.rescheduleCallCb}
							scheduleDate={item.schedule_date}
							scheduleService={item.schedule_service || ''}
							listDetailId={item.list_detail_id}
						/>
					</td>
				</tr>
			);
		});
	}

	expandCollapseModifier = () => {
		this.setState({ open: !this.state.open });
	}

	openScheduledCallsModal = (event) => {
		event.stopPropagation();
		this.open('showScheduledCallsModal');
	}

	render() {
		const { translations, selectedLanguage } = this.props;
		return (
			<div className={`panel${this.props.theme} panel-default${this.props.theme}`}>
				<div className={`panel-heading panel-heading${this.props.theme}`}>
					<h3 className="panel-title">
						<a className="show btn-icon" onClick={this.expandCollapseModifier}>
							<span className="icon icon-flow-tree icon-right-space"></span>
							<span className="anchor_text">{translations.autoDialer[selectedLanguage]}</span>
							<span className="icon icon-select-arrows pull-right"></span>
							<span className="icon icon-clock pull-right" style={{marginRight: 10}} 
								onClick={(event) => this.openScheduledCallsModal(event)}
								data-toggle="modal"
								data-target="#tableModal"
							/>
						</a>
					</h3>
				</div>
				<Collapse in={this.state.open}>
					<div>
						<ul className="padding-0 margin-bottom-0">
							<ul className="list-group link-list margin-bottom-0">
								<li className={`list-group-item compress border-bottom${this.props.theme} a${this.props.theme}`}>
									<a href className={"show" + (this.state.processingSkipAdminTime ? " disabled" : "") + " btn-icon"} onClick={this.skipAdminTime} disabled>
										{!this.state.processingSkipAdminTime && !this.state.successSkipAdminTime && <span className="icon icon-controller-fast-forward"></span>}
										{!this.state.processingSkipAdminTime && this.state.successSkipAdminTime && <span ref={(skipAdminSuccessIcon => this.skipAdminSuccessIcon = skipAdminSuccessIcon)} className="icon-success"></span>}
										{this.state.processingSkipAdminTime && <span className="fa fa-spinner fa-spin"></span>}
										&nbsp;&nbsp;<span className="anchor_text">{translations.skipAdmininistrativeTime[selectedLanguage]}</span>
									</a>
								</li>
								<li className={`list-group-item compress border-bottom${this.props.theme} a${this.props.theme}`}>
									<a href className={"show" + (this.state.processingGetcontactImmediately ? " disabled" : "") + " btn-icon"} onClick={this.getcontactImmediately} disabled>
										{!this.state.processingGetcontactImmediately && !this.state.successGetcontactImmediately && <span className="icon icon-controller-fast-forward"></span>}
										{!this.state.processingGetcontactImmediately && this.state.successGetcontactImmediately && <span ref={(contactImmediatelySuccessIcon => this.contactImmediatelySuccessIcon = contactImmediatelySuccessIcon)} className="icon-success"></span>}
										{this.state.processingGetcontactImmediately && <span className="fa fa-spinner fa-spin"></span>}
										&nbsp;&nbsp;<span className="anchor_text">{translations.getContactImmediately[selectedLanguage]}</span>
									</a>
								</li>
							</ul>
							{this.props.autoDialerCalls.length > 0 && <div><div>
								<table className={`table table${this.props.theme} table-condensed table-hover${this.props.theme} small m-a-0`}>
									<thead>
										<tr>
											<th>{translations.hour[selectedLanguage]}</th>
											<th>{translations.service[selectedLanguage]}</th>
											<th>{translations.phoneNumber[selectedLanguage]}</th>
											<th style={{ maxWidth: 56, width: 56 }} />
										</tr>
									</thead>
									<tbody>
										{this.renderCalls()}
									</tbody>
								</table>
							</div>
							</div>
							}
							{this.props.autoDialerCalls.length == 0 &&
								<div className="panel-body text-center small">
									{translations.noAutoDialerCalls[selectedLanguage]}
								</div>
							}
						</ul>
						<ul className="list-group link-list margin-bottom-0">
							<li className={`list-group-item compress text-center border-top${this.props.theme} a${this.props.theme}`}>
								<a
									onClick={() => this.open('showCallsModal')}
									className="show"
									data-toggle="modal"
									data-target="#tableModal"
								>
									{translations.seeMore[selectedLanguage]}
								</a>
							</li>
						</ul>
					</div>
				</Collapse>
				<CallsModal
					type="autoDialer"
					callAction="getAuotoDialerCalls"
					callDataParam="items"
					columns={this.state.columns}
					callsData={this.props.autoDialerCalls}
					showCallsModal={this.state.showCallsModal}
					has_tags={this.state.has_tags}
					handleClose={() => this.close('showCallsModal')}
					headerText={translations.autoDialer[selectedLanguage]}
					callMenuProps={this.state.callMenuProps}
					panelOutgoingServiceCb={this.outgoingServiceCb}
					panelRescheduleCallCb={this.rescheduleCallCb}
					panelGetCalls={this.refreshCalls}
				/>
				<ScheduledCalls
					type="scheduled_autoDialer"
					callAction="getScheduledAuotoDialerCalls"
					callDataParam="items"
					columns={this.state.scheduledCallsColumns}
					callsData=''
					showCallsModal={this.state.showScheduledCallsModal}
					handleClose={() => this.close('showScheduledCallsModal')}
					headerText={translations.scheduledCalls[selectedLanguage]}
				/>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		autoDialerCalls: state.autoDialerCalls,
		agentInfo: state.agentInfo,
		outgoingEvent: state.callEvents.outgoing,
		translations: state.languages.translations,
		selectedLanguage: state.languages.selectedLanguage,
		darkMode: state.common.darkMode,
		theme: state.common.theme,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		skipAdminTime,
		getAuotoDialerCalls,
		setAutoDialerCalls,
		doCall,
		getcontactImmediately,
		showWebphone
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AutomotivePanel);



// WEBPACK FOOTER //
// ./src/agent/automotive-panel.js